module.exports = __webpack_public_path__ + "media/images/new/cell_coverage_maps@2x-896ace718d74338ff81a9ed4089de43e.jpg";